import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Spinner, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { SectionCard } from '../SectionCard/SectionCard';
import { ContactItem } from './ContactItem/ContactItem';
import styles from './ContactsCard.module.scss';
import { useContactsCard } from './hooks/useContactsCard';
export const GetContactsCardTID = (parentTestId)=>getTestIds(parentTestId);
export function ContactsCard(param) {
    let { clientId, isArchived, isReadOnly } = param;
    const { ContactsCardTestIds: TID } = useMemo(()=>GetContactsCardTID(), []);
    const { t: contactsTexts } = useLocaleKeys('client.detail.summary.contacts');
    const { contacts, isLoading, isError, isEmpty, hasContacts, onAddContact, onEditContact, onChangeRole, onDeleteContact, mappingsByContactId } = useContactsCard(clientId, isArchived);
    const rowActions = {
        isReadOnly,
        onEdit: onEditContact,
        onChangeRole,
        onDelete: onDeleteContact
    };
    return /*#__PURE__*/ _jsxs(SectionCard, {
        bi: {
            name: 'client_detail_contacts_card'
        },
        testId: TID.Root(),
        title: contactsTexts.title(),
        showActions: !isReadOnly,
        bodyClassName: styles.scrollableBody,
        actions: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'client_detail_add_contact'
            },
            testId: TID.AddContactButton(),
            variant: "paragraph2",
            skin: "primary",
            weight: "normal",
            underline: "none",
            onClick: onAddContact,
            children: contactsTexts.addContact()
        }),
        children: [
            isLoading && /*#__PURE__*/ _jsx(Spinner, {
                testId: TID.Loading()
            }),
            isError && /*#__PURE__*/ _jsx(Typography, {
                testId: TID.Error(),
                skin: "error",
                children: contactsTexts.loadError()
            }),
            isEmpty && /*#__PURE__*/ _jsx(Typography, {
                testId: TID.Empty(),
                variant: "paragraph2",
                weight: "light",
                skin: "disabled",
                children: contactsTexts.emptyMessage()
            }),
            hasContacts && /*#__PURE__*/ _jsx(Column, {
                testId: TID.ContactsList(),
                gap: 16,
                children: contacts.map((contact)=>/*#__PURE__*/ _jsx(ContactItem, _object_spread({
                        contact: contact,
                        mappings: mappingsByContactId[contact.id()],
                        testId: TID.ContactRow(contact.id())
                    }, rowActions), contact.id()))
            })
        ]
    });
}
